import { ColDef } from 'ag-grid-community';
import { EstadosFirmaService } from 'src/app/pages/panelControl/services/estados-firma.service';
import { stringComparator } from 'src/app/shared/utils/ag-grid-comparators';



export class GridColDefsData {

    public columDefs:ColDef[] = [
            {field: 'estadoString', headerName: 'Estado', sortable: true, resizable: true, width: 130, suppressSizeToFit: true,
            //se modifica la vista y añade el icono del estado
              cellRenderer: params => {
                let estadoFirma = this.GetIcono(params.value);
                return estadoFirma;
              }
            },
            {field: 'empleado', headerName: 'Firmante principal',sortable: true, resizable: true, width: 220,
              cellRenderer: params => {
                if(params.value){
                  let empleado = params.value.toUpperCase();
                  return empleado
                }else return null

              }
             },
            {field: 'fechaCreacion', headerName: 'Fecha creación', sortable: true, resizable: true, width: 150, cellClass:['celda-grid'],
              valueGetter: params => {
                return params.data.fechaCreacion ?? params.data.fechaUltimaActualizacion;
              },
              cellRenderer: params => {
                if(params.value){
                  let date = new Date(params.value);
                  return date.toLocaleDateString("en-GB");
                }else return null

              }
            },
            {field: 'fechaFirma', headerName: 'Fecha envío/firma', sortable: true, resizable: true, width: 170, cellClass:['celda-grid'],
              valueGetter: params => {
                // return params.data.fechaFirma ?? params.data.fechaEnvio;
                return params.data.fechaFirma ?? params.data.fechaEnvio ?? params.data.fechaUltimaActualizacion;
              },
              //pasamos data a formato en-GB
              cellRenderer: params => {
                if(params.value){
                  let date = new Date(params.value);
                  return date.toLocaleDateString("en-GB");
                }else return null

              },

              filterParams: {
                comparator: (filterDate: Date, cellValue: any) => {
                    let cellDate = new Date(cellValue);
                    cellDate = new Date(cellDate.getFullYear(), cellDate.getMonth(), cellDate.getDate());
                    if (cellDate < filterDate) return -1;
                    else if (cellDate > filterDate) return 1;
                    else return 0;
                },
              },
            },

            {field: 'tipoEnvio', headerName: 'Tipo de dosier', sortable: true, resizable: true, width:  280, cellClass:'ellipsis-cell',
              comparator: stringComparator
             },

            {field: 'nombreCentro', headerName: 'Centro', sortable: true, resizable: true, width: 280, cellClass:'ellipsis-cell',
            cellRenderer: params => {
              let codigoCentroGrid = params.data.codigoCentro == null ? '' : params.data.codigoCentro;
              let nombreCentroGrid = params.data.nombreCentro == null ? '' : params.data.nombreCentro;
              return `${codigoCentroGrid} - ${nombreCentroGrid}`
            }},
            {field: 'nombreEmpresa', headerName: 'Empresa', sortable: true, resizable: true, width: 280, cellClass:'ellipsis-cell',
            cellRenderer: params => {
              let codigoEmpresaGrid = params.data.codigoEmpresa == null ? '' : params.data.codigoEmpresa;
              let nombreEmpresaGrid = params.data.nombreEmpresa == null ? '' : params.data.nombreEmpresa;
              return `${codigoEmpresaGrid} - ${nombreEmpresaGrid}`
            }},
            {field: 'emailEmpleado', headerName: 'Email', sortable: true, resizable: true, width: 180, cellClass:'ellipsis-cell' },
            {field: 'telefonoEmpleado', headerName: 'Teléfono', sortable: true, resizable: true, width:  100 },
            {field: 'numeroDocumentos', headerName: 'Docs', sortable: true, resizable: true, width: 70, suppressSizeToFit: true},
            // {field: 'descargar', headerName: 'Descargar', sortable: false, resizable: false, cellRenderer: 'iconoDescargar', width: 100 },
            {field: 'estadoRlt', headerName: 'RLT', sortable: true, resizable: true, width: 140,
              cellRenderer: params => {
                let estadoRlt = this.GetEstadoRlt(params.data);
                return estadoRlt;
              }, //hide: true // comprobamos desde la api si el modulo está habilitado
            },
            {field: 'fechaContrato', headerName: 'Fecha contrato', sortable: true, resizable: true, width: 140, cellClass:['celda-grid'],
              cellRenderer: params => {
                let date: Date;
                if(params.value){
                  date = new Date(params.value);
                  return date.toLocaleDateString("en-GB");
                } else return null
              }
            },
            {field: 'nifEmpleado', headerName: 'DNI', sortable: true, resizable: true, width:  110 }
          ];
          //cellRender, aisla la imagen que se mete en la celda y se captura el click de la imagen

  GetColor(estadoString: string, soloIcono: boolean = false)

  {
    let icono = new EstadosFirmaService().GetIcono(estadoString);
    let estado='';
    let style = 'width: 8px; height: 50px; margin-right: 15px;';
    if (icono == 'icon-draft') style += 'background-color: var(--hs-grey4); border-top-left-radius: 8px;';
    else if (icono == 'icon-double-check') style += 'background-color: var(--hs-green2);';
    else if (icono == 'icon-check') style += 'background-color: var(--hs-orange2);';
    else if (icono == 'icon-rejected') style += 'background-color: var(--hs-rosa);';
    else if (icono == 'icon-pending') style += 'background-color: var(--hs-orange2);';
    else if (icono == 'icon-clock') style += 'background-color: var(--hs-rosa);';
    else if (icono == 'icon-alert') style += 'background-color:  var(--hs-red); border-bottom-left-radius: 8px;';
    else if (icono == 'icon-close') style += 'background-color:  var(--hs-rosa);';
    // if(soloIcono) return `<svg style="${style}"><use xlink:href="#${icono}"></use></svg>`;
    // else
    return `<span style="${style}"></span>`;
    //<span">${estado}</span>
  }

  GetIcono(estadoString: string, soloIcono: boolean = false, modal: boolean = false)
  {
    let icono = new EstadosFirmaService().GetIcono(estadoString);
    let style:string;
    if(soloIcono==true) style = 'border-radius: 16px; padding: 4px 10px; margin: 10px 0; font-size: 12px; align-self: center;'
    else style = 'border-radius: 16px; padding: 4px 10px; margin: 10px 0; font-size: 12px;'

    if (icono == 'icon-draft') style += 'background-color: var(--hs-grey4); color: var(--hs-grey1); font-weight: 400;';
    else if (icono == 'icon-double-check') style += 'background-color: var(--hs-green2); color:#006128; font-weight: 400;';
    else if (icono == 'icon-check' && modal == false) style += 'background-color: var(--hs-orange2); color: #965B02; font-weight: 400; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 85px; height: 23px; display:block; padding: 0px 10px;';
    else if (icono == 'icon-check' && modal == true) style += 'background-color: var(--hs-orange2); color: #965B02; font-weight: 400;';
    else if (icono == 'icon-rejected') style += 'background-color: var(--hs-rosa); color: #BE2121; font-weight: 400;';
    else if (icono == 'icon-pending') style += 'background-color: var(--hs-orange2); color: #965B02; font-weight: 400;';
    else if (icono == 'icon-clock') style += 'background-color: var(--hs-rosa); color: #BE2121; font-weight: 400;';
    else if (icono == 'icon-alert') style += 'background-color:  var(--hs-red); color: #fff; font-weight: 700;';
    else if (icono == 'icon-close') style += 'background-color:  var(--hs-rosa); color: #BE2121; font-weight: 400;';
    // if(soloIcono) return `<svg style="${style}"><use xlink:href="#${icono}"></use></svg>`;
    // else
    return `<span style="${style}">${estadoString}</span>`;
    // return `<svg style="${style}"><use xlink:href="#${icono}"></use></svg><span">${estadoString}</span>`;
  }


  GetEstadoRlt(params:any){
    let styleGreen = "width: 10px; height: 10px; border-radius: 50px; background-color: #3FA677; margin-right: 10px; display: inline-block";
    let styleYellow = "width: 10px; height: 10px; border-radius: 50px; background-color: #F7C351; margin-right: 10px; display: inline-block";

    if(params.estadoRlt === true) return `<span style="${styleGreen}"></span><span>Enviado</span>`;
    else if(params.estadoRlt === false) return `<span style="${styleYellow}"></span><span>Pendiente</span>`;
    else return ``;
  }

}
